
import  "../src/App.css";
import { Route, Routes } from "react-router-dom";
import { Home } from "./componentes/Home";

import { EditarTarea } from "./componentes/EditarTarea";
import { AgregarTarea } from "./componentes/AgregarTarea";
import Login from "./componentes/Login";
import { ProtectedRoutes } from "./componentes/ProtectedRoutes";
import { FuturasTareas } from "./componentes/FuturasTareas";
import EditarFuturaTarea from "./componentes/EditarFuturaTarea";
import AgregarFuturaTarea from "./componentes/AgregarFuturaTarea";
import { Categorias } from "./componentes/Categorias";
import AgregarCategoria from "./componentes/AgregarCategoria";
import EditarCategoria from "./componentes/EditarCategoria";
import { Toaster } from "react-hot-toast";
import { DuplicarTarea } from "./componentes/DuplicarTarea";

function App() {
  return (
    <>
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/"
        element={
          <ProtectedRoutes>
            <Home />
          </ProtectedRoutes>
        }
      />
      <Route
        path="/crearTarea"
        element={
          <ProtectedRoutes>
            {" "}
            <AgregarTarea />
          </ProtectedRoutes>
        }
      />

      <Route
        path="/crearFuturaTarea"
        element={
          <ProtectedRoutes>
            {" "}
            <AgregarFuturaTarea />
          </ProtectedRoutes>
        }
      />
      <Route
        path="/editarTarea/:id"
        element={
          <ProtectedRoutes>
            <EditarTarea />
          </ProtectedRoutes>
        }
      />

      <Route
        path="/editarFuturaTarea/:id"
        element={
          <ProtectedRoutes>
            <EditarFuturaTarea />
          </ProtectedRoutes>
        }
      />

      <Route
        path="/futuraTarea"
        element={
          <ProtectedRoutes>
            <FuturasTareas />
          </ProtectedRoutes>
        }
      />
      <Route
        path="/categorias"
        element={
          <ProtectedRoutes>
            <Categorias />
          </ProtectedRoutes>
        }
      />
      <Route
        path="/crearCategoria"
        element={
          <ProtectedRoutes>
            <AgregarCategoria />
          </ProtectedRoutes>
        }
      />
      <Route
        path="/editarCategoria/:id"
        element={
          <ProtectedRoutes>
            <EditarCategoria />
          </ProtectedRoutes>
        }
      />
      <Route
        path="/duplicar/:id"
        element={
          <ProtectedRoutes>
            <DuplicarTarea />
          </ProtectedRoutes>
        }
      />
    </Routes>

    <Toaster
    position="top-right"
    reverseOrder={false}
    containerStyle={
    {top: 55}  
    }
    />
    </>
  );
}

export default App;
